module.exports = __webpack_public_path__ + "static/GT-Haptik-Bold-01b84c4e3588dbd730e5d02a51df1006.woff";